@if (showBanner$ | async) {
  <div class="not-supported" [@fadeInOut]="animationState">
    <div class="top-bar-not-supported">
      <mat-card>
        <mat-card-content [innerHTML]="'browser_not_supported.content' | translate">
        </mat-card-content>
        <div class="progress-container">
          <div class="progress-bar" [style.width.%]="progressPercentage$ | async"></div>
        </div>
      </mat-card>
    </div>
  </div>
}
